import { useConversationsStore } from '@/stores/conversations/conversations.store';
import type { ConversationType } from '@/types/conversation.types';
import type { UpdateContactType } from '@/types/events/update-contact.ts';

export default function contactUpdate(data: UpdateContactType): void {
  const conversationsStore = useConversationsStore();

  conversationsStore.updateOrInsertConversation(data.conversationData);

  if ((conversationsStore.activeConversation as ConversationType)?.conversationId === data.conversationId) {
    conversationsStore.updateActiveConversation(data.conversationData);
  }
}
